<template>
    <v-app-bar elevation="0" class="main-header on-top" height="64" fixed color="primary" dark>
        <v-btn icon class="mx-1" @click.stop="TOGGLE_DRAWER">
            <template v-if="DRAWER_STATE">
                <v-icon size="28" :class="$vuetify.theme.dark ? 'primary--text' : null">mdi-arrow-left</v-icon>
            </template>
            <template v-else>
                <v-icon size="28" :class="$vuetify.theme.dark ? 'primary--text' : null">mdi-menu</v-icon>
            </template>
        </v-btn>
        <div>
            <router-link :to="{ path: `${domain.domainName}/index` }">
                <v-img lazy-src="https://www.ausa.com.mx/img/Ausa-logov3.PNG" max-height="55" max-width="45"
                    src="https://www.ausa.com.mx/img/Ausa-logov3.PNG" class="imagenLogo"></v-img>
            </router-link>
        </div>
        <v-spacer></v-spacer>
        <v-menu offset-y bottom nudge-bottom="10" left>
            <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" style="font-size: 28px" icon class="mr-2" @click="ObtenerHistorial">
                    <v-icon size="28">
                        mdi-history
                    </v-icon>
                </v-btn>
            </template>
            <v-list>
                <div id="histo" class="mr-n2"
                    style="margin-bottom: 0; overflow: auto; max-height: 400px; width: 300px; white-space: nowrap; overflow-y: auto;">
                    <v-list-item-group color="primary" v-if="historial.length > 0">
                        <v-list-item v-for="(item, i) in historial" :key="i">
                            <v-list-item-icon class="ma-n1 justify-center">
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-icon color="primary" v-bind="attrs" v-on="on" class="pt-6">{{ item.icon
                                            }}</v-icon>
                                    </template>
                                    <span>{{ item.ai }}</span>
                                </v-tooltip>
                            </v-list-item-icon>
                            <v-list-item two-line @click="Detalle(item)">
                                <v-list-item-content>
                                    <v-list-item-title class="pb-2" style="font-size: 14px !important;">
                                        Reporte: {{ item.nrreporte }} - {{ item.svindice }}
                                    </v-list-item-title>
                                    <v-list-item-subtitle class="text-truncate" style="font-size: 13px !important;">
                                        Cliente: {{ item.cliente }}
                                    </v-list-item-subtitle>
                                </v-list-item-content>

                            </v-list-item>
                        </v-list-item>
                    </v-list-item-group>
                    <v-list-item-group v-if="historial.length == 0">
                        <v-list-item>
                            No existe registro
                        </v-list-item>
                    </v-list-item-group>
                </div>
            </v-list>
        </v-menu>
        <v-btn icon>
            <v-icon @click="validarBusqueda">mdi-magnify</v-icon>
        </v-btn>
        <div>
            <v-text-field class="mt-7" v-if="expandir" placeholder="Número de Reporte" v-model="nrreporte"
                @keyup.enter="Buscar()" @change="validarReporte" @keypress="validarRegex($event, 'N')"
                autofocus></v-text-field>
        </div>
        <v-menu offset-y bottom nudge-bottom="10" left>
            <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" style="font-size: 28px" icon @click="ObntenerNotificacion" class="mr-2">
                    <v-badge :value="notificationsBadge" color="error" :content="total" overlap>
                        <v-icon size="28">
                            mdi-bell-outline
                        </v-icon>
                    </v-badge>
                </v-btn>
            </template>
            <v-list>
                <v-row no-gutters class="d-flex align-center mb-3 px-5 py-1 mx-1">
                    <v-col cols="12" md="6" class="d-sm-flex justify-md-start justify-space-between align-center">
                        Notificaciones Recientes
                    </v-col>
                    <v-col cols="12" md="6" class="d-sm-flex justify-space-between align-center justify-md-end">

                        <v-btn class="ma-1" color="primary" plain @click="Eliminar()">
                            Eliminar Notificación
                        </v-btn>
                    </v-col>
                </v-row>
                <div id="noti" @scroll="CargarNoti()" class="mr-n2"
                    style="margin-bottom: 0; overflow: auto; max-height: 400px; width: 450px; white-space: nowrap;">
                    <v-list-item-group color="primary">
                        <v-list-item v-for="(item, i) in messages" :key="i">
                            <v-list-item-icon class="ma-n1 justify-center">
                                <v-icon color="success" class="pt-6">mdi-flag</v-icon>
                            </v-list-item-icon>
                            <v-list-item subheader three-line @click="navegar(item.clave, item.enlace)">
                                <v-list-item-content style="width: 250px; min-height: 100px;">
                                    <v-list-item-title class="pb-2"
                                        style="font-size: 11px !important; text-align: justify;">
                                        {{ item.proceso }}
                                    </v-list-item-title>
                                    <v-list-item-subtitle
                                        style="font-size: 12px !important; text-align: justify; min-height: 100%;">
                                        {{ item.mensaje }}
                                    </v-list-item-subtitle>
                                </v-list-item-content>
                                <v-list-item-action style="width: 60px">
                                    <v-list-item-action-text style="font-size: 10px !important;">
                                        {{ item.fecha }}
                                    </v-list-item-action-text>
                                </v-list-item-action>
                            </v-list-item>
                        </v-list-item>
                    </v-list-item-group>
                </div>
            </v-list>
        </v-menu>
        <v-menu min-width="180" offset-y bottom left nudge-bottom="10">
            <template v-slot:activator="{ on, attrs }">
                <v-avatar size="40" v-bind="attrs" v-on="on" class="mr-3">
                    <template v-if="imagenCargada">
                        <img :src="perfil.usfotonew ? perfil.usfotonew : 'https://www.ausa.com.mx/FotosPerfil/perfil.png'"
                            alt="perfil" />
                    </template>
                    <template v-else>
                        <v-progress-circular indeterminate color="gray" size="24"></v-progress-circular>
                    </template>
                </v-avatar>
            </template>
            <v-list>
                <div class="d-flex justify-center my-3">
                    <v-btn width="80%" large outlined color="primary" class="text-capitalize" @click="cerrarSesion()">
                        Cerrar
                        Sesión
                    </v-btn>
                </div>
            </v-list>
            <v-list>
                <div class="d-flex justify-center my-3">
                    <v-btn width="80%" large outlined color="primary" class="text-capitalize" @click="perfilUsuario2()">
                        Perfil
                        de Usuario
                    </v-btn>
                </div>
            </v-list>
        </v-menu>
        <div class="greeting-text mr-3 d-none d-md-block">
            Hola, <span>{{ nombre }}</span>
        </div>
    </v-app-bar>
</template>

<script>
import { mapActions, mapState } from "vuex";
import config from "@/config.js";
import MetodosGenerales from "@/utils/metodosgenerales.vue.js";
import General from '@/services/ReporteGeneral/ReporteGeneral.service.js';
import PerfilServ from '@/services/main/perfil.service.js';
import SerBusqueda from '@/services/Busqueda/Busqueda.service.js';

export default {
    name: "Header",
    components: {},
    data: () => ({
        imagenCargada: false,
        config,
        searchCollapse: true,
        nombre: "",
        nrreporte: "",
        buscarclose: true,
        aux_nrreporte: "",
        expandir: false,
        messages: [],
        numpagina: 1,
        total: 0,
        NoMoreData: false,
        notificationsBadge: true,
        inProgress: false,
        perfil: [],
        historial: [],
        HistorialBadge: true,
    }),
    computed: {
        ...mapState({ drawer: (state) => state.drawer }),
        ...mapState(["domain", "informationPage"]),
        DRAWER_STATE: {
            get() {
                return this.drawer;
            },
        },
    },
    methods: {
        ...mapActions(["TOGGLE_DRAWER"]),
        async Detalle(item) {
            let fomrd = new FormData();
            fomrd.append("reporte", item.nrreporte);
            fomrd.append("indice", item.svindice);
            fomrd.append("aiclave", item.aiclave);
            await SerBusqueda.ObtenerUrlHistorial(fomrd).then((data) => {
                window.location.href = data;
            });
            //if (item.url != '')
            //    window.location.href = item.url;
        },
        async ObtenerHistorial() {
            let frmdata = new FormData();
            frmdata.append("uslogin", MetodosGenerales.ObtenerUserName());
            await SerBusqueda.ObtenerHistorial(frmdata).then(respo => {
                if (respo) {
                    const data = JSON.parse(respo);
                    this.historial = data;
                    this.totalhistoria = data.length;
                }
                else
                    this.historial = [];
            });
            this.HistorialBadge = true;
        },
        CargarNoti() {
            let scroll = document.getElementById('noti');
            if (scroll.offsetHeight + scroll.scrollTop >= scroll.scrollHeight && !this.NoMoreData && !this.inProgress) {
                this.ObntenerNotificacion();
            }
        },
        async ObntenerNotificacion() {
            this.messages = [];
            this.numpagina = 1;
            this.NoMoreData = false;
            this.inProgress = false;
            let formdata = new FormData();
            formdata.append("numpagina", this.numpagina);
            this.inProgress = true;
            await General.Notificacion(this, formdata).then(data => {
                if (data.length > 0) {
                    for (let x in data) {
                        this.messages.push({
                            clave: data[x].clave,
                            enlace: data[x].enlace,
                            proceso: data[x].proceso,
                            mensaje: data[x].mensaje,
                            fecha: data[x].fecha
                        });
                    }
                    this.NoMoreData = this.numpagina == Math.ceil(this.total / 10) ? true : false;
                    this.numpagina += 1;


                    this.inProgress = false;
                }
            });

        },
        navegar(clave, enlace) {
            this.Elimina(clave);
            this.ObntenerNotificacion();
            if (enlace != '')
                window.location.href = enlace;

        },
        async Elimina(clave) {
            let formdata = new FormData();
            formdata.append("tnclave", clave);
            await General.Eliminar(this, formdata).then(async data => {
                await this.VerNoti();
                await this.ObntenerNotificacion();
            });
        },
        async Eliminar() {
            if (this.messages.length > 0) {
                await General.EliminarNotificacion(this).then(data => {
                    if (data == true) {
                        this.VerNoti();
                        this.$swal({
                            position: "center",
                            icon: "success",
                            title: "Éxito",
                            text: "Se eliminaron las notificaciones",
                            allowOutsideClick: false,
                            allowEscapeKey: false,
                            showConfirmButton: true,
                            timer: 2000,
                        });
                        this.ObntenerNotificacion();
                    }
                    else {
                        this.$swal({
                            position: "center",
                            icon: "error",
                            title: "Error",
                            text: "No se puede guardar, por favor intente de nuevo más tarde, si el problema persiste, pónganse en contacto con el equipo de asistencia técnica",
                            allowOutsideClick: false,
                            allowEscapeKey: false,
                            showConfirmButton: true,
                            confirmButtonText: "Aceptar",
                        });
                    }
                });
            }
        },
        async VerNoti() {
            let formdata = new FormData();
            formdata.append("numpagina", 1);
            await General.Notificacion(this, formdata).then(data => {
                if (data.length > 0) {
                    this.total = data[0].tam;
                    this.NoMoreData = this.numpagina == Math.ceil(data[0].tam / 10) ? true : false;
                    this.notificationsBadge = true;
                }
                else
                    this.notificationsBadge = false;
            });
        },
        async obtenerNombre() {
            let formdata = new FormData()
            formdata.append("uslogin", MetodosGenerales.ObtenerUserName());
            let response = await this.axios.post(
                `${this.domain.domainNameForApi}ObtenerNombre`, formdata
            );
            this.nombre = response.data;
            this.perfil = await PerfilServ.DatosPerfil();

            setTimeout(() => {
                this.imagenCargada = true;
            }, 3000);
        },

        cerrarSesion() {
            sessionStorage.removeItem("BusquedaFiltrox");
            MetodosGenerales.cerrarSesion(
                this.domain.domainNameForApi,
                this.informationPage
            );
        },
        Buscar() {
            if (this.nrreporte != "") {
                let changeTime = window.sessionStorage.getItem("CambioContraseña");
                if (changeTime == 0 || changeTime == -1) {
                    this.$router.push({ name: "Perfil" }).catch(error => error);
                } else {
                    MetodosGenerales.deleteSession("LiderPantalla");
                    let comprobarnrreporte = parseInt(this.nrreporte);
                    if (isNaN(comprobarnrreporte)) {
                        this.$swal({
                            position: "center",
                            icon: "warning",
                            title: "Error",
                            text: "Número del reporte incorrecto",
                            showConfirmButton: true,
                        });
                        this.nrreporte = "";
                    } else {
                        var URLactual = window.location.href;
                        if (URLactual != this.domain.domainNameWithHttp + "BusquedaGeneral") {
                            this.$router.push({
                                name: "busquedageneral",
                                params: { data: this.nrreporte.trim() },
                            });
                        } else if (
                            URLactual ==
                            this.domain.domainNameWithHttp + "BusquedaGeneral"
                        ) {
                            this.$root.$emit("busquedaReporte", this.nrreporte);
                        }
                        this.nrreporte = "";
                    }
                }

            }
        },
        validarReporte: function (e) {
            this.aux_nrreporte = e.replace(/\s/g, "");
            this.aux_nrreporte = this.aux_nrreporte.replace(/[a-zA-Z]/g, "");
            this.nrreporte = this.aux_nrreporte.split("-")
            this.nrreporte = this.nrreporte[0]
        },
        validarRegex(evt, tipo) {
            return MetodosGenerales.validarRegex(evt, tipo);
        },
        validarBusqueda() {
            if (this.nrreporte != "") {
                this.Buscar();
            } else {
                this.expandir = !this.expandir;
            }
        },
        perfilUsuario2() {
            this.$router.push({ name: "Perfil" }).catch(error => error);
        }
    },
    async mounted() {
        this.obtenerNombre();
        this.VerNoti();
    },
};
</script>

<style src="@/views/shared/header/Header.scss" lang="scss"></style>
<style>
@media screen and (max-width: 527px) {
    .imagenLogo {
        display: none !important;
    }
}

@media screen and (min-width: 528px) {
    .imagenLogo {
        display: block !important;
    }
}

.on-top {
    position: fixed !important;
    /* z-index: 10 !important; */
}

.notification:before,
.notification:after {
    content: " ";
    display: table;
}

.notification:after {
    clear: both;
}

.notification-media {
    float: left;
    margin-right: 10px;
}

.notification-content {
    overflow: hidden;
}

.notification-heading {
    line-height: 20px;
    margin-bottom: 0;
    margin-top: 0;
}

.notification-timestamp {
    float: right;
    font-size: 12px;
    line-height: 20px;
}

.notification-text {
    margin-bottom: 0;
}

.truncate {
    display: inline-block;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    vertical-align: top;
    white-space: nowrap;
}

.list-group-item {
    position: relative;
    display: block;
    padding: 10px 15px;
    margin-bottom: -1px;
    background-color: #fff;
    border: 1px solid #eee;
}
</style>
